import { RunningTradeCustomFilterActionEnum } from '../../types';
import { IActionTypeMenu, IPredefinedLotItem } from './types';

export const actionTypeMenus: IActionTypeMenu[] = [
  {
    label: 'All',
    key: RunningTradeCustomFilterActionEnum.ALL,
  },
  {
    label: 'Buy',
    key: RunningTradeCustomFilterActionEnum.BUY,
  },
  {
    label: 'Sell',
    key: RunningTradeCustomFilterActionEnum.SELL,
  },
];

export const predefinedLot: IPredefinedLotItem[] = [
  {
    label: '100',
    value: 100,
  },
  {
    label: '200',
    value: 200,
  },
  {
    label: '500',
    value: 500,
  },
  {
    label: '1000',
    value: 1000,
  },
];
